import React from 'react';
import { useCenters } from '../hooks/useCenters';

export default function CenterFilter({ value, onChange }) {
  const { centers, loading } = useCenters();

  return (
    <select
      value={value || ''}
      onChange={(e) => onChange(e.target.value || null)}
      className="border border-gray-300 rounded-lg px-3 py-2 text-sm bg-white min-w-[180px]"
      disabled={loading}
    >
      <option value="">All centers</option>
      {centers.map((center) => (
        <option key={center.id} value={center.id}>
          {center.name}{!center.is_active ? ' (inactive)' : ''}
        </option>
      ))}
    </select>
  );
}
